import { useLocation, useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';
import { Divider, useTheme } from "@mui/material";
import { tokens } from "../../theme";

import {TextField, Typography, Slider }from '@mui/material';
import Stack from '@mui/material/Stack';
import { CloseRounded, Description } from "@mui/icons-material";

import { useSelector } from 'react-redux';
import Modal from '@mui/material/Modal';
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import env from "react-dotenv";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box className="outer"
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#f2f0f0'),
        // color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        // border: '3px solid',
        //  borderColor: (theme) =>
        //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
        // p: 1,
        //  borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: '500',
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};


const Edit = ({onSelected, open , onClose}) => {
 const navigate = useNavigate();
  const { rowIndex } = useParams();
  const [errors, setErrors] = useState({});
  const [ row , setRow] = useState();
  const [monthyear, setMonthYear] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const submitLockRef = useRef(false);
 

  const location = useLocation();
  useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );

  const [data, setData] = useState({
    id:"",
    YearMonth: "",
    ABPB: "0",
    BJRL: "",
    BJTL: "",
    PBS: "",
    RPPS: "",
    RPLBS: "",
    LBS: "",
    TCEJ : "",
    RS: "",
    MEP:"",
  });
  
  const getDataFromDb = async () => {
    try {
      if (onSelected) {
        const { id, field, dataId} = onSelected;
        const rIndex = dataId;
        setRow(dataId);       
          try { 
              const res = await fetch(
              `${process.env.REACT_APP_MISBACKEND_URL}/rejection/${rIndex}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            const response = await res.json();
            
            setData(response[0]);
          } catch (error) {
            console.log(error);
          }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDataFromDb(data);   
  }, [onSelected]);
  

  const handleChange = (e) => {
  
    setData({ ...data, [e.target.name]: e.target.value });
   
    
  }

  const validateForm = () => {
    const errors = {};
    // if (data.WorkType.trim() == 'Machine Maintenance' && !data.Machine.trim()) {
    //     errors.Machine = 'Machine is required if worktype is machine maintenance';
    //     console.log(errors.Machine);
    // }

    return errors;
  };
  function Bar() {
    return (
      <Box
        sx={{
          height: 10,
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? 'rgba(0, 0, 0, 0)'
              : 'rgb(0, 0, 0, 0)',
        }}
      />
    );
  } 
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const modalStyle1 = {
    maxWidth: 600,marginLeft:"330px", marginTop:"30px",
  
    };
    const handleSubmitOnDB = async (e) => {
      e.preventDefault();
      if (isSaving || submitLockRef.current) {
        return;
      }
  
      const newErrors = validateForm(data);
      setErrors(newErrors);
      if(monthyear !== null){
        data['YearMonth'] = moment(new Date(monthyear)).format("MMM-yyyy").toString()
      }
      if (Object.keys(newErrors).length === 0) {
        try{
          submitLockRef.current = true;
          setIsSaving(true);
          const res = await fetch(
            `${process.env.REACT_APP_MISBACKEND_URL}/updateRejection`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );
          
          onClose();
          navigate('../efficiencyHome/4');        
          navigate(0);
          
        } catch (error) {
          console.log(error);
        } finally {
          submitLockRef.current = false;
          setIsSaving(false);
        }
      }else {
        console.log(`Form submission failed
        due to validation errors.`);
    } 
    };  


  return (open) ? (
  
          <Modal style={modalStyle1} className="outer1" open={open} onClose={onClose}>
          <div style={{ width: "100%", 
                borderColor: colors.blueAccent[300],border: '1px solid',
                    p: 1,backgroundColor: colors.primary[400],
                    borderRadius: 1}}  >
          <button className="addButton" onClick={() => onClose()}><CloseRounded/></button>

          <form style={{ marginLeft:"5px",marginRight:"5px",marginTop:"5px",
                marginBottom:"5px",
                borderColor: '#E0E0E0',
                    p: 2,
                    borderRadius: 1}} onSubmit={handleSubmitOnDB}>
          <h5 style={{ color: '#000000', marginTop:"20px"}} className="text-center">Update Supply Record</h5>
          <Divider  sx={{       
              border: '1px solid',
              borderColor: colors.grey[200]
            
            }}/>   
          <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(1, 2fr)', gap: 2 ,m:1}}>
                <Item>
                  <FormControl size="medium" fullWidth>
                    <label>YearMonth</label>
                    <DatePicker
                    disabledKeyboardNavigation
                    showMonthYearPicker
                    required
                    value={data.YearMonth}
                    disabled
                    name="YearMonth"
                    selected={monthyear}          
                    className="dPick"
                    popperProps={{
                      positionFixed: true // use this to make the popper position: fixed
                    }}                    
                      autoComplete="off"        
                      onChange={(monthyear) => setMonthYear(new Date(monthyear))}
                      dateFormat="MMM-yyyy"
                    />
                    </FormControl>
                </Item>
          </Box>
         
          <Box className="outerbox" sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 2 ,m:1}}>
            <Item>
              <FormControl size="medium" fullWidth>
                   <label>ABPB</label>
                  <TextField size="small" value={data.ABPB} type="number" name="ABPB" onChange={handleChange}  variant="outlined" />
                  <Bar/>  
                  <label>BJRL</label>
                    <TextField size="small"  value={data.BJRL} type="number" name="BJRL" onChange={handleChange} variant="outlined" />
                    <Bar/>
                    <label>BJTL</label>
                    <TextField size="small" value={data.BJTL} type="number"  name="BJTL" onChange={handleChange} variant="outlined" />
                    <Bar/>
                    <label>PBS</label>
                    <TextField size="small" value={data.PBS} type="number"  name="PBS" onChange={handleChange} variant="outlined" />
                    <Bar/>
                    <label>RPPS</label>
                    <TextField size="small" value={data.RPPS} type="number"  name="RPPS" onChange={handleChange}  variant="outlined" />
                    <Bar/>
              </FormControl>
            </Item>
         
            <Item>
              <FormControl size="medium" fullWidth>
                    <label>RPLBS</label>
                    <TextField size="small" value={data.RPLBS} type="number" name="RPLBS" onChange={handleChange}  variant="outlined" />
                    <Bar/>
                    <label>LBS</label>
                    <TextField size="small" value={data.LBS} type="number" name="LBS" onChange={handleChange} variant="outlined" />
                    <Bar/>
                    <label>TCEJ</label>
                    <TextField size="small" value={data.TCEJ} type="number"  name="TCEJ" onChange={handleChange} variant="outlined" />
                    <Bar/>
                    <label>RS</label>
                    <TextField size="small"  value={data.RS} type="number"  name="RS" onChange={handleChange} variant="outlined" />
                    <Bar/>
                    <label>MEP</label>
                    <TextField size="small" value={data.MEP} name="MEP" type="number" onChange={handleChange} variant="outlined" />
                    
              </FormControl>
            </Item>
          </Box>
          <Box sx={{marginTop:'10px',marginBottom:'10px',  display: 'flex',  justifyContent: 'center', padding:'3px'}}>
              <Stack spacing={2} direction="row">
                <button margin="2" size="medium" className="btn btn-primary center">Update</button>
                {/* <button onClick={handleClose} className="btn btn-primary">Close</button> */}
              </Stack>
          </Box>



        </form>
    </div>
    </Modal>
  ) : ""
};

export default Edit;